import { StudentInvoiceData } from "../../components/report/student";

export default function StudentInvoiceReport() {
  return (
    <>
      <StudentInvoiceData />
    </>
  );
}
